













































import { throttle } from '@utils/utils';
import { getMerchantList, queryServiceStaffUserList } from '@services/merchant/user-role-manage-controller';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import { setCookie } from '@utils/cookie';
import generalSSO from '@utils/generalSSO';

@Component({
    name: 'roleList',
    components: {},
})
export default class RoleList extends Vue {
    @Prop({ type: String, default: '' })
    multiUserToken: string;
    @Prop({ type: String, default: '' })
    phone: string;
    /** 控制选择账号 */
    showRoleList: boolean;

    @Getter('userInfo') userInfo: any;
    @Action('setUserInfo') setUserInfo: any;
    isLoading: Boolean = false;
    singedMerchants: any = [];
    keyword: string = '';
    selectIndex: any = null;
    pageSize: number = 10;
    pageNum: number = 1;
    noMore: Boolean = false;
    scrollLoad: Function = throttle(this.scrollLoadMore, 50);
    totalNum: number = 0;

    mounted() {
        this.searchRoleList();
        this.$nextTick(() => {
            const scrollContent = this.$refs['role-table_content'];
            scrollContent?.addEventListener('scroll', this.scrollLoad, true);
        });
    }

    searchRole() {
        this.pageNum = 1;
        this.searchRoleList();
    }

    // async searchRoleList(pageSize = 10, pageNum = 1) {
    //     const { keyword = '' } = this;
    //     try {
    //         const params = {
    //             currentPage: pageNum,
    //             pageSize,
    //             searchName: keyword,
    //         };
    //         const { data } = await getMerchantList(params);
    //         const { paging, userOrgVOS } = data;
    //         this.totalNum = paging.total;
    //         if (pageNum === 1) {
    //             this.singedMerchants = userOrgVOS;
    //         } else {
    //             this.singedMerchants = [...this.singedMerchants, ...userOrgVOS];
    //         }
    //         if (paging.total <= this.singedMerchants.length) {
    //             this.noMore = true;
    //         }
    //     } catch (error) {
    //         this.$message('获取商家列表失败，请刷新重试', 'error');
    //     } finally {
    //         this.isLoading = false;
    //         if (!this.noMore) {
    //             setTimeout(() => {
    //                 const scrollContent = this.$refs['role-table_content'];
    //                 scrollContent?.addEventListener('scroll', this.scrollLoad, true);
    //             }, 500);
    //         }
    //     }
    // }
    async searchRoleList(pageSize = 10, pageNum = 1) {
        const { keyword = '' } = this;
        try {
            const params = {
                pageNo: pageNum,
                pageSize,
                keyword,
                phone: this.phone,
                token: this.multiUserToken,
            };
            const { data } = await queryServiceStaffUserList(params);
            const { total, serviceStaffUserVOList } = data;
            this.totalNum = total;
            this.singedMerchants = serviceStaffUserVOList;
        } catch (error) {
            // 过期时候的页面处理,弹出错误信息，回到登录页
            this.$message({
                message: error.message,
                type: 'error',
            });
            this.$emit('hideAccountList');
        } finally {
            this.isLoading = false;
            if (!this.noMore) {
                setTimeout(() => {
                    const scrollContent = this.$refs['role-table_content'];
                    scrollContent?.addEventListener('scroll', this.scrollLoad, true);
                }, 500);
            }
        }
    }

    selectRole(index) {
        this.singedMerchants = this.singedMerchants.map((item, i) => {
            if (index === i) {
                item.selected = true;
                this.selectIndex = i + 1;
            } else {
                item.selected = false;
            }
            return item;
        });
    }

    submit(index) {
        this.singedMerchants = this.singedMerchants.map((item, i) => {
            if (index === i) {
                item.selected = true;
                this.selectIndex = i + 1;
            } else {
                item.selected = false;
            }
            return item;
        });
        if (!this.selectIndex) {
            this.$message({
                message: '请选择商家身份',
                type: 'error',
            });
        } else {
            const user = this.singedMerchants[this.selectIndex - 1] || {};
            this.chooseUserSubmit(user);
            // const merchantInfo = this.singedMerchants[this.selectIndex - 1] || {};
            // setCookie('locallifeSessionCode', merchantInfo.locallifeSessionCode);
            // this.setUserInfo({
            //     ...this.userInfo,
            //     ...merchantInfo,
            // });
            // this.$emit('goToHome');
        }
    }
    async chooseUserSubmit(user) {
        this.isLoading = true;
        const { chooseUser } = generalSSO;
        try {
            const result = await chooseUser({
                userId: user.ksUserId,
                multiUserToken: this.multiUserToken,
                phone: this.phone,
            });
            const authToken = result['locallife.merchant.api.at'];
            const sid = 'locallife.merchant.api';
            this.$emit('subAccountBusinessLogin', { authToken, sid });
        } catch (error) {
            // 账号异常情况下的处理
            this.$message({
                message: error.error_msg,
                type: 'error',
            });
            this.$emit('hideAccountList');
        }
        this.isLoading = false;
    }

    scrollLoadMore() {
        const scrollContent = this.$refs['role-table_content'];
        const scrollCell = this.$refs['role-table_cell'];
        const currentScrollTop = scrollContent.scrollTop;
        const currentOffsetHeight = scrollCell.offsetHeight;
        const currentClientHeight = scrollContent.clientHeight;
        if (currentScrollTop + currentClientHeight >= currentOffsetHeight - 10) {
            if (!this.isLoading && !this.noMore) {
                this.isLoading = true;
                this.pageNum += 1;
                this.searchRoleList(this.pageSize, this.pageNum);
                scrollContent?.removeEventListener('scroll', this.scrollLoad, true);
            }
        }
    }
    handlePageClick(pageNum) {
        this.searchRoleList(this.pageSize, pageNum);
    }
}
